import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentpune() {



    const cardData = {

keyword: "Urbania On Rent Pune",

headingDescription:
    "Rising Cab Service offers premium Urbania On Rent in Pune for corporate travel, weddings, airport transfers, family trips, and outstation group journeys. Our Force Urbania vehicles are designed for maximum comfort with high-roof spacious interiors, luxury push-back seats, powerful air conditioning, ambient lighting, ample luggage space, and experienced professional drivers. With doorstep pickup across Pune, flexible rental options, 24/7 support, and transparent pricing, we ensure a safe, stylish, and comfortable travel experience for large groups and VIP transportation needs.",

topPlaces: [
    {
        title: "Lonavala & Khandala Luxury Escape",
        description:
            "Lonavala and Khandala are the most popular hill stations near Pune, known for lush green valleys, waterfalls, misty landscapes, and scenic viewpoints. Urbania is ideal for luxury group travel, offering spacious seating and premium comfort for families, corporate teams, and wedding groups enjoying monsoon drives and weekend getaways."
    },
    {
        title: "Mahabaleshwar Premium Hill Tour",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool weather. Urbania rental ensures a premium travel experience for large groups visiting waterfalls, viewpoints, and scenic attractions with maximum comfort and relaxation."
    },
    {
        title: "Goa Luxury Group Vacation",
        description:
            "Goa is a top long-distance destination from Pune known for beaches, nightlife, and adventure activities. Urbania on rent is perfect for VIP group travel, wedding trips, and luxury vacations, ensuring a smooth and comfortable highway journey for large groups."
    },
    {
        title: "Shirdi Sai Baba Premium Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in India dedicated to Sai Baba. Urbania provides premium group travel for darshan, ensuring comfort, space, and a relaxed journey for families and devotees visiting the holy shrine."
    },
    {
        title: "Nashik Vineyard & Spiritual Tour",
        description:
            "Nashik is known for vineyards, Trimbakeshwar Jyotirlinga, and temples. Urbania is ideal for wine tours, corporate outings, and spiritual trips, offering a premium travel experience across vineyards and religious destinations."
    },
    {
        title: "Ashtavinayak Darshan Luxury Trip",
        description:
            "The Ashtavinayak circuit includes eight sacred Ganpati temples across Maharashtra. Urbania is perfect for large group pilgrimage tours, providing maximum comfort and smooth travel for devotees completing the spiritual journey."
    },
    {
        title: "Alibaug Premium Coastal Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Urbania rental is ideal for luxury group outings, corporate retreats, and beach vacations from Pune with comfortable seating and smooth travel."
    },
    {
        title: "Konkan Scenic Coastal Drive",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, and Tarkarli offers beautiful beaches, greenery, and scenic roads. Urbania ensures a comfortable long-distance journey for luxury coastal tours and group vacations from Pune."
    },
    {
        title: "Aurangabad Heritage Luxury Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. Urbania is ideal for premium heritage tours, educational trips, and family cultural journeys from Pune with comfort and style."
    },
    {
        title: "Pune Corporate & VIP Travel",
        description:
            "Urbania is widely used in Pune for corporate travel, wedding transport, and VIP group movement. It offers spacious interiors, luxury seating, and a smooth ride experience for important events and professional travel needs."
    }
],



services: [
{
name: "Urbania on Rent in Pune",
description: "Rising Cab Service offers Urbania on Rent in Pune for premium group travel with maximum comfort and safety. Our luxury Urbania vans come with spacious seating, air-conditioning, push-back seats, and professional chauffeurs, making them ideal for family trips, corporate travel, weddings, and outstation journeys across Maharashtra."
},
{
name: "17 Seater Urbania on Rent Pune",
description: "Book 17 Seater Urbania on Rent Pune for large group travel with premium comfort and smooth riding experience. Perfect for long-distance tours, pilgrimage trips, and corporate outings with well-maintained interiors, ample luggage space, and experienced drivers."
},
{
name: "20 Seater Urbania Booking Pune",
description: "Our 20 Seater Urbania Booking Pune service is designed for bigger groups seeking luxury travel solutions. Enjoy comfortable seating, AC interiors, and safe journeys for weddings, events, and outstation tours with professional service support."
},
{
name: "Urbania for Outstation Pune",
description: "Rising Cab Service provides Urbania for Outstation Pune for long-distance travel to destinations like Goa, Mumbai, Nashik, Shirdi, and hill stations. Experience luxury seating, smooth suspension, and reliable drivers ensuring safe and comfortable journeys."
},
{
name: "Urbania Van Rent Pune",
description: "Book Urbania Van Rent Pune for premium group transportation with high-end comfort and spacious interiors. Ideal for corporate tours, airport transfers, and family trips with 24x7 booking availability."
},
{
name: "Pune Urbania Traveller On Rent Price",
description: "Get the best Pune Urbania Traveller On Rent Price with affordable and transparent rates. We offer competitive pricing for hourly, per km, and full-day packages suitable for all types of group travel needs."
},
{
name: "Urbania Hire Pune to Mumbai",
description: "Rising Cab Service offers Urbania Hire Pune to Mumbai for safe and comfortable intercity travel. Enjoy premium AC vans, professional chauffeurs, and timely pickup/drop service for business and leisure trips."
},
{
name: "Urbania for Pune Darshan",
description: "Book Urbania for Pune Darshan to explore the city’s famous landmarks in luxury comfort. Perfect for tourists and groups with flexible sightseeing routes, AC comfort, and experienced drivers."
},
{
name: "Urbania Booking Pune Airport",
description: "Our Urbania Booking Pune Airport service ensures hassle-free group pickup and drop from Pune Airport. Ideal for corporate teams, tourists, and families with punctual and reliable service."
},
{
name: "Luxury Urbania on Rent in Pune",
description: "Rising Cab Service provides Luxury Urbania on Rent in Pune for premium travel experiences. Enjoy top-class interiors, plush seating, air-conditioning, and smooth rides for weddings, corporate events, and outstation tours."
},
{
name: "Urbania on Rent in Pimpri Chinchwad",
description: "Book Urbania on Rent in Pimpri Chinchwad for reliable and comfortable group travel. Our service includes luxury vans with experienced drivers and flexible booking options for all travel needs."
},
{
name: "Urbania on Rent in PCMC",
description: "Rising Cab Service offers Urbania on Rent in PCMC for corporate and family travel. Enjoy spacious seating, AC comfort, and safe journeys for local and outstation trips."
},
{
name: "17 Seater Urbania on Rent Pimpri",
description: "Our 17 Seater Urbania on Rent Pimpri service is ideal for medium and large groups. Travel comfortably with premium interiors, smooth suspension, and professional chauffeurs."
},
{
name: "20 Seater Urbania Traveller in Chinchwad",
description: "Book 20 Seater Urbania Traveller in Chinchwad for luxury group transportation. Perfect for weddings, corporate events, and outstation tours with spacious seating and AC comfort."
},
{
name: "Pimpri Chinchwad Urbania on Rent",
description: "Rising Cab Service provides Pimpri Chinchwad Urbania on Rent for all types of group travel. Enjoy premium vehicles, punctual service, and safe long-distance journeys."
},
{
name: "Urbania Van on Rent PCMC",
description: "Book Urbania Van on Rent PCMC for high-end group travel solutions. Ideal for airport transfers, corporate trips, and family tours with luxury seating and reliable drivers."
},
{
name: "Urbania Luxury Vehicle on Rent Pimpri",
description: "Our Urbania Luxury Vehicle on Rent Pimpri service offers premium vans with comfortable seating, AC interiors, and professional drivers for safe and elegant travel experiences."
},
{
name: "Urbania Hire in Pimpri Chinchwad",
description: "Rising Cab Service provides Urbania Hire in Pimpri Chinchwad for weddings, corporate outings, and family tours. Enjoy luxury travel with well-maintained vehicles and experienced chauffeurs."
},
{
name: "Urbania Traveller Booking in PCMC",
description: "Book Urbania Traveller Booking in PCMC for hassle-free luxury group transportation. We ensure comfort, safety, and timely service for all your travel requirements."
}
],

tableData: [
["Urbania on Rent in Pune","17 Seater Urbania on Rent Pune"],
["20 Seater Urbania Booking Pune","Urbania for Outstation Pune"],
["Urbania Van Rent Pune","Pune Urbania Traveller On Rent Price"],
["Urbania Hire Pune to Mumbai","Urbania for Pune Darshan"],
["Urbania Booking Pune Airport","Luxury Urbania on Rent in Pune"],
["Urbania on Rent in Pimpri Chinchwad","Urbania on Rent in PCMC"],
["17 Seater Urbania on Rent Pimpri","20 Seater Urbania Traveller in Chinchwad"],
["Pimpri Chinchwad Urbania on Rent","Urbania Van on Rent PCMC"]
],




whychoose: [
    {
        WhyChooseheading: "Premium Urbania on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides Force Urbania rental services in Pune for family vacations, corporate travel, wedding transportation, airport transfers, pilgrimages, and luxury group tours."
    },
    {
        WhyChooseheading: "Luxury Travel Experience for Every Journey",
        WhyChoosedescription: "Urbania offers premium pushback seats, spacious interiors, excellent legroom, modern design, and superior comfort for local and outstation travel."
    },
    {
        WhyChooseheading: "Ideal for Family and Corporate Groups",
        WhyChoosedescription: "Urbania is a perfect choice for family tours, corporate outings, destination weddings, business travel, school groups, and VIP guest transportation."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Tours",
        WhyChoosedescription: "Urbania rentals are available for Pune city travel as well as Mahabaleshwar, Goa, Shirdi, Nashik, Mumbai, Konkan, Kolhapur, Lonavala, and other destinations."
    },
    {
        WhyChooseheading: "Spacious Seating with Modern Amenities",
        WhyChoosedescription: "Passengers enjoy comfortable seating, air conditioning, large windows, luggage space, charging points, and a smooth travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Urbania pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Safe Travel",
        WhyChoosedescription: "Our professional chauffeurs ensure safe driving, timely reporting, smooth highway journeys, and excellent customer service."
    },
    {
        WhyChooseheading: "Perfect for Tours, Events, and Pilgrimages",
        WhyChoosedescription: "Urbania is widely preferred for Ashtavinayak tours, Shirdi trips, corporate events, destination weddings, Konkan tours, and family holidays."
    }
]
};

const faqData = [
    {
        question: "What is Urbania on Rent in Pune?",
        answer: "Urbania rental service provides a premium luxury passenger vehicle for group travel, family tours, corporate transportation, and outstation trips."
    },
    {
        question: "Can I hire Urbania for outstation travel?",
        answer: "Yes, Urbania vehicles are available for destinations across Maharashtra and other states."
    },
    {
        question: "Is Urbania suitable for corporate travel?",
        answer: "Yes, Urbania is one of the most preferred luxury vehicles for executive transportation, conferences, meetings, and corporate events."
    },
    {
        question: "Can Urbania be booked for weddings and family functions?",
        answer: "Yes, Urbania is commonly hired for wedding guest transportation, family events, and destination weddings."
    },
    {
        question: "Is the vehicle comfortable for long-distance journeys?",
        answer: "Yes, Urbania offers spacious seating, premium interiors, and excellent comfort for long-distance travel."
    },
    {
        question: "Can families hire Urbania for vacations and sightseeing tours?",
        answer: "Yes, Urbania is ideal for family holidays, Konkan tours, hill station trips, and group vacations."
    },
    {
        question: "Do you provide Urbania for pilgrimage tours?",
        answer: "Yes, Urbania vehicles are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Are airport transfer services available with Urbania?",
        answer: "Yes, Urbania can be booked for Pune Airport transfers, Mumbai Airport transfers, and VIP guest transportation."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book Urbania on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Bhosale",
        feedback:
            "We hired an Urbania for our Mahabaleshwar family tour. The seating comfort, spacious cabin, and smooth ride made the journey truly enjoyable for everyone.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Swati Kulkarni",
        feedback:
            "Our corporate team traveled in Urbania for an outstation event. The vehicle was luxurious, clean, and extremely comfortable for long-distance group travel.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Urbania on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/urbania-on-rent-pune.jpg",
"description": "Book Urbania on Rent in Pune with Rising Cab Service for premium group travel, corporate tours, airport transfers, and outstation trips. Available in 17 and 20 seater luxury AC Urbania vans with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹28/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/urbania-on-rent-pune"
}
};





    return (
        <div>
<Helmet>
  <title>Urbania on Rent in Pune | 17–20 Seater Luxury Van | +91 9272511548</title>

<meta
 name="description"
 content="Book Urbania on Rent in Pune for premium group travel, corporate tours, airport transfers, and outstation trips. Get 17 & 20 seater luxury AC vans with driver."
/>

<meta
 name="keywords"
 content="urbania on rent pune, 17 seater urbania pune, 20 seater urbania booking pune, urbania van rent pune, urbania for outstation pune, pune urbania traveller price, urbania hire pune to mumbai, urbania for pune darshan"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentpune;